import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { GetRenewalSummaryResponse } from '@responses/renewal-summary';
import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';

import type { QueryFactory } from './factory.types';

/** Summary of Changes: the renewal's saved summary plus its latest generation job. */
export const fetchRenewalSummary = async (renewalId: string): Promise<GetRenewalSummaryResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: `/submissions/${renewalId}/renewal_summary`,
  });
  const response = await axios<GetRenewalSummaryResponse>(networkPayload);
  return response.data;
};

export const RENEWAL_SUMMARY_KEY = (renewalId: string) => ['renewal-summary', renewalId] as const;

export const renewalSummaryQueries = {
  detail: (renewalId: string) =>
    queryOptions({
      queryKey: RENEWAL_SUMMARY_KEY(renewalId),
      queryFn: () => fetchRenewalSummary(renewalId),
      refetchOnWindowFocus: false,
    }),
} satisfies QueryFactory;
